<template>
	<div class="treeView">
		<div class="home">
			<ul v-for="menuItem,index in treeData">
				<li>
					<a href="javascript:void(0)" :class="'layer'+menuItem[menuCode]">
						<span @click="menuItem[children]?toggleTree(menuItem[menuCode],treeData):isFolder(menuItem[menuCode],treeData)">
							<span :class="menuItem[children]?'el-icon-plus':'el-icon-document'"></span>
							{{menuItem[menuName]}}
						</span>
					</a>
				</li>
			</ul>
		</div>		
	</div>
</template>

<script>
export default {
	props: ['getTreeData','defaultProps','openNode','title'],
	data(){
		return{
			oClass: "",
			isOpen: {},
			code: 0,
			children: this.defaultProps.children,
			menuName: this.defaultProps.menuName,
			menuCode: this.defaultProps.menuCode,
		}
	},
	computed: {
		treeData(){
			if(this.getTreeData.length>0){
				let vue = this
				$(".layer").remove()
				setTimeout(function(){
					for(var i=0;i<vue.getTreeData.length;i++){
						vue.treeFn(vue.getTreeData[i])					
					}	
					if(vue.openNode==0){
						for(var i in vue.isOpen){   //variable 为属性名
						  	if(vue.isOpen[i]){
						  		vue.toggleTree(i,{},true)	
						  	}
						}	
						for(var i=0;i<vue.getTreeData.length;i++){
							$(".layer"+vue.getTreeData[i][vue.menuCode]).css("color","#fff")				
						}
					}else{
						for(var i in vue.isOpen){   //variable 为属性名
						  	vue.isOpen[i] = false
						}
						if(vue.openNode.parentId==0){
							for(var i=0;i<vue.getTreeData.length;i++){
								if(vue.getTreeData[i].id==vue.openNode[vue.menuCode]){
									if(vue.getTreeData[i][vue.children]){
										vue.toggleTree(vue.openNode[vue.menuCode],vue.getTreeData[i])
									}else{
										vue.isFolder(vue.openNode[vue.menuCode],vue.getTreeData[i])
									}
								}
								
							}
						}else{
							for(var i=0;i<vue.getTreeData.length;i++){
								if(vue.openNode.parentId==vue.getTreeData[i][vue.menuCode]){
									vue.toggleTree(vue.getTreeData[i][vue.menuCode],vue.getTreeData[i])
									for(var j=0;j<vue.getTreeData[i][vue.children].length;j++){
										if(vue.getTreeData[i][vue.children][j][vue.menuCode]==vue.openNode[vue.menuCode]){
											if(vue.openNode[vue.children]){
												vue.toggleTree(vue.openNode[vue.menuCode],vue.getTreeData[i][vue.children][j])
											}else{
												vue.isFolder(vue.openNode[vue.menuCode],vue.getTreeData[i][vue.children][j])
											}
										}
										
									}
									break;
								}
							}	
						}						
					}
				},100)
			}				
			return this.getTreeData
		},
	},
	methods: {
		treeFn(data){	
			if(data[this.children]){	
				for (var j=0;j<data[this.children].length;j++){
					if(data[this.children][j][this.children]){
						this.oClass = "el-icon-plus"
					}else{
						this.oClass = "el-icon-document"
					}
					if($('.layer'+data[this.menuCode]+'>ul').length==0&&$('.layer'+data[this.menuCode]+'>ul')){
						$('.layer'+data[this.menuCode]).append("<ul style='list-style: none;padding-left: 20px;display: none;' class='layer'></ul>")
					}
					$('.layer'+data[this.menuCode]+'>ul').append('<li><a href="javascript:void(0)" class="layer'+data[this.children][j][this.menuCode]+'" style="color: #fff;text-decoration: none;"><span style="padding: 3px 0;display: inline-block;"><span class="'+this.oClass+'"></span> '+data[this.children][j][this.menuName]+'</span></a></li>')				
					var vue = this
					if(data[this.children][j][this.children]){
						$('.layer'+data[this.children][j][this.menuCode]+'>span').on("click",function(){
							vue.toggleTree(parseInt($(this).parent().attr("class").split("layer")[1]),data.children)
						})
					}else{
						$('.layer'+data[this.children][j][this.menuCode]+'>span').on("click",function(){
							vue.isFolder(parseInt($(this).parent().attr("class").split("layer")[1]),data.children)
						})
						$('.layer'+data[this.children][j][this.menuCode]+'>span').on("click",function(){
							vue.closeArr(parseInt($(this).parent().attr("class").split("layer")[1]),data.children)
						})
					}
					this.treeFn(data[this.children][j])
				}
			}else{
				return
			}				
		},
		isFolder: function(menuCode,data,bol){
			this.closeArr(menuCode,data)
			for (let i=0; i<data.length; i++) {
				if(data[i][this.menuCode]==menuCode){
					data = data[i]
				}
			}
			if(!bol){
				this.$emit("nodeClick",data)		
			}
			$('.layer'+menuCode).css("color","goldenrod")
		},
		toggleTree: function(menuCode,data,bol){
			this.isOpen[menuCode] = !this.isOpen[menuCode]	
			if(bol){
				$(".layer"+menuCode).css("color","#fff")
			}else{
				let dataArr = {}
				if(data.id){
					dataArr = data
				}else{
					for (let i=0; i<data.length; i++) {
						if(data[i][this.menuCode]==menuCode){
							dataArr = data[i]
						}
					}					
				}	
				this.$emit("nodeClick",dataArr)
				this.isFolder(menuCode,{},true)	
			}
			if(this.isOpen[menuCode]){
				this.closeArr(menuCode,data)	
				$('.layer'+menuCode+'>span>span').removeClass("el-icon-plus")
				$('.layer'+menuCode+'>span>span').addClass("el-icon-minus")
				$('.layer'+menuCode+'>ul').css("display","block")				
			}else{
				$('.layer'+menuCode+' a').css("color","#fff")
				$('.layer'+menuCode+'>span>span').addClass("el-icon-plus")
				$('.layer'+menuCode+'>span>span').removeClass("el-icon-minus")
				$('.layer'+menuCode+' ul').css("display","none")
				$('.layer'+menuCode+' ul>li>a>ul').prev().children("span").addClass("el-icon-plus")
				$('.layer'+menuCode+' ul>li>a>ul').prev().children("span").removeClass("el-icon-minus")
				if(parseInt($('.layer'+menuCode+' ul>li>a').attr("class"))){
					this.isOpen[parseInt($('.layer'+menuCode+' ul>li>a').attr("class").split("layer")[1])]=false
				}				
			}
		},
		closeArr: function(menuCode,data){
			if(!data.parentId&&data.length==0){
				data = this.getTreeData 
			}
			for(var i=0; i<data.length;i++){
				if(menuCode!=data[i][this.menuCode]){
					if(data[i][this.children]){
						$('.layer'+data[i][this.menuCode]).css("color","#fff")
						$('.layer'+data[i][this.menuCode]+' a').css("color","#fff")
						this.isOpen[parseInt(data[i][this.menuCode])]=false
						$('.layer'+data[i][this.menuCode]+'>span>span').addClass("el-icon-plus")
						$('.layer'+data[i][this.menuCode]+'>span>span').removeClass("el-icon-minus")
						$('.layer'+data[i][this.menuCode]+' ul').css("display","none")
						$('.layer'+menuCode+' ul>li>a>ul').prev().children().addClass("el-icon-plus")
						$('.layer'+menuCode+' ul>li>a>ul').prev().children().removeClass("el-icon-minus")
						if($('.layer'+menuCode+' ul>li>a').attr("class")){
							this.isOpen[parseInt($('.layer'+menuCode+' ul>li>a').attr("class").split("layer")[1])]=false
						}					
					}else{
						$('.layer'+data[i][this.menuCode]).css("color","#fff")
					}
				}
			}
		}			
	},
	mounted(){
		
	},
	components: {
	}
}
</script>

<style scoped>
	.treeView{
		height: 100%;
		background: #267cb7;
		width: 100%;
		padding: 0 10px;
	    float: left;
	}
	.tree{
		color: #fff;
	}
	ul {
		list-style: none;
		padding-left: 15px;
	}
	a{
		color: #fff;
		text-decoration: none;
	}
	li.active{
		background: #16a0d3;
   		border-radius: 3px;		
	}
</style>


// WEBPACK FOOTER //
// src/components/treeView.vue